// extracted by mini-css-extract-plugin
export default {"button":"button-_XMEp","content":"content-kCSMY","expanded":"expanded-bIj1f"};